var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_417_2249",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_417_2249",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAD7UlEQVR4nO2cPWgUQRSAvzujohHBIoWYYEAsbJJKFEQQIoJIRCsR0ULtU6qdhYJtmoCttYmCgr2FPyiIFhKICCLmF2xCjGJMLEZQ72b2bud2Z97tvA9ek+zevDff3s1csvsgPleAWWCjYrEAjBY4T6XTBzwk/sSVGV8Km62SOYFJNvaEhQjRbAPGgXXiT1TyQg4C09iTfgnsj5eaFzXgGrBGlwnZhEn8B83J/gTuAJujZefHTuA+XfgO2Qc8w57oNOZd020MAzM017MG3LD8XAyXgGXsMu4BO+Kl5s0FYIXmepYwGxUsv4tOH/AAu4gF4HS81LzZitmM2Gp6DQz+c6woIVnb2SfA7nipedMPPMde011gS8PxIoRkbWe/AWOxEuuQY8A8zTWtApcd50QXUrXtLGRvaWeAoYxzowmp4nYWzJZ2EvsF9gjY1eL8KEIGgaeWwTeAj8CRUIkUzDDwAfuW9iZQb+M1ggs5g3s7W8VYBI7nmJ/gQmyLXFXjBTCQc36CC4k9SaHCtqX1mZ9c1DwHTAGfuYHm+cn1Oj2eg3oPKBgRF1o7uwYlICpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCpEGCqkOOrA7RgDB7+rIhCd1NULTFle41ORCbpQIf8zALyxnL8KnCo4Rysq5C+HgTnLuUvA0RJytKJCDOcwd/Y3nvcW2FtSjlZSF1LD3Odre/TiMeZm7aCkLKQX953x40TataYqZA/wynLcd8zzlNFIUcghBCzeLlITImbxdpGKkBpwC/82IMG6AaUixLV454nc3YCKeBxB737PJtf86B8XhVGEkE7f1lLCxTvMQ661hqgD14FfeSesaGJPXMhwffMW1Q3oc5uJdHOsY3ZYts//IYR1AzpJtaXMAecdtV/E3g1oERj5c0xwIa2oYjegHkxnCltN2g0oMP24m7CJ7Qa0HZjA/q12GbgaK7EOGcF8HDXWtIL5+LIRXUhVuwGNYZroNNak3YACk7Wl1W5AgTkAvKe5JtHdgM6i3YCyCCqkDny1DFrVEN8NqG4ZsKoxgXYDEoV2A4qMiAtN/x8iDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBUiDBVSHNoNqGA6qUu7AZWAb13aDagkfOrSbkAlkrcuMQ0FUhei3YAC0U5d2g0oIK3q0m5AgcmqS8Ti7SI1IWIWbxepCBG3eLtIRYht8c5qKBCNVISIW7xdpChExOLtotWVVLUQs3i78G15140xifkyKJpZ4k9U2SFy8XYxirufSRViHnc3oNL5DWESzqz/hAgsAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModular);
export default __webpack_public_path__ + "static/media/modular.6b83cf1caf8a71580589a01b09391c40.svg";
export { ForwardRef as ReactComponent };